module.exports = __webpack_public_path__ + "media/process/Process-Hero-376e8e5a.png";